/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { TransferListItem } from "./TransferListItem";
import * as t from "io-ts";

// required attributes
const PaymentNoticeItemR = t.interface({
  paymentAmount: t.Integer,

  primaryCreditorInstitution: t.string
});

// optional attributes
const PaymentNoticeItemO = t.partial({
  transferList: t.readonlyArray(TransferListItem, "array of TransferListItem")
});

export const PaymentNoticeItem = t.intersection(
  [PaymentNoticeItemR, PaymentNoticeItemO],
  "PaymentNoticeItem"
);

export type PaymentNoticeItem = t.TypeOf<typeof PaymentNoticeItem>;
